<template>
  <div>
    <template v-if="loading">
      <b-overlay :show="loading" rounded spinner-small>
        <b-form-input disabled />
      </b-overlay>
    </template>
    <template v-else>
      <base-select
        v-model.number="selected"
        :show-place-holder="false"
        :hide-search="false"
        :options="options"
        :option-html="true"
        :disabled="disabled"
        :error="isFailValidation"
      >
      </base-select>
      <div v-show="isFailValidation" class="is-invalid-feedback-message">
        {{ textValidation }}
      </div>
    </template>
  </div>
</template>

<script>
const renderOption = (options, valuePading) => (item) => {
  options.push({
    id: item.id,
    text:
      "<span style='padding-left: " +
      valuePading +
      "px;'>" +
      item.name +
      "</span>",
  });
  if (item.children && item.children.length) {
    item.children.map(renderOption(options, valuePading + 20));
  }
};

import handleValidateMixin from "@/mixins/handle-validate-mixin";
import singleSelectionMixin from "@/mixins/single-selection-mixin";
import facilityOrganizationService from "@/services/manage/facility/organization";
import { mapGetters } from "vuex";
import { GET_ID_ORGANIZATION_NEXT_LOGIN } from "@/store/modules/Organization/types";

export default {
  name: "OrganizationTreeSingleSelection",
  mixins: [handleValidateMixin, singleSelectionMixin],
  props: {
    currentId: {
      type: [Number, String],
      default: "",
    },
    facilityCode: {
      type: String,
      default: "",
    },
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
    ...mapGetters("Organization", [GET_ID_ORGANIZATION_NEXT_LOGIN]),
  },
  created() {
    this.getParentList();
    this.options = [
      {
        id: "",
        text: "<span>" + this.$t("panel.label_please_choose") + "</span>",
      },
    ];
  },
  methods: {
    async getParentList() {
      try {
        this.loading = true;
        const response = await facilityOrganizationService.search({
          facility_code: this.facilityCode,
          login_organization: this.GET_ID_ORGANIZATION_NEXT_LOGIN,
        });
        response.data.map(renderOption(this.options, 0));
        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.handleError(err);
      }
    },
  },
};
</script>

<style></style>
